import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import { HASACCESS } from '../../../shared/utility';
import { DATATABLE_CONFIG, DAILY_SHIFT_SUBMENU_ID, COSTCENTER_ID } from '../../../shared/Config';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class CostCenter extends Component {
    state = {
        selectedItems: []
    }


    
    orgRender = (rowData) => {
    let orgUnitval = (rowData.orgunit || '').toString().trim().toLowerCase();
    let value = this.props.GetOrgUnit
        .filter(unit => (unit.value || '').toString().trim().toLowerCase() === orgUnitval)
        .reduce((_, el) => `${el.label}_${el.id}`, '');
    return value || rowData.orgunit;
}


    componentDidMount(){   
        this.getAccess = HASACCESS(COSTCENTER_ID);     
        this.props.getMasterTableList('GetCostCenter');    
        this.props.getMasterKeywordList('OrgUnit');
    }

   

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
        <Link to={"/CostCenter/edit/"+rowData.costcenterid}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
        <Link to={"/CostCenter/view/"+rowData.costcenterid}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>            }        
        </div>;
    }


 

  
    render() {   
        

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }

        

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        

        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Cost Center</h1>
               
                        <div className="p-grid">
                            

                            <div className="p-col-12 p-md-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                    <Link to="/CostCenter/add/new"><Button style={{float: 'right'}} label="Add Cost Center" icon="pi pi-plus" className="ml1" /></Link>
                                }

                                {/* {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                    <Button onClick={this.delete} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                } */}
                                </div>                                
                            </div>
                      
                                                    
                        <div className="p-col-12" style={{marginTop:'2em'}}>


                     
                        <DataTable value={tableData} 
                         selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                         globalFilter={this.state.globalFilter} header={header}  dataKey="costcenterid"   {...DATATABLE_CONFIG}>
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="costcenterid"  style={{display:'none'}}/>
                                {/* <Column field="costcenterid"  header="Cost Center ID"/> */}
                                <Column field="costcenternum" header="Cost Center No." />
                                <Column field="desc" header="Short Description"  />       
                                <Column field="glaccount" header="Cost Element (GL Account)" />
                                {/* <Column field="CostCenterLongdescription" header="Long Description"/>
                                <Column field="CostCenterSapCode" header="SAP Code"/> */}
                                <Column field="orgunit" header="Org Unit" body={this.orgRender}/>
                                <Column body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        
        
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(CostCenter);